const CARRY_OVER_PROPERTY_PREFIX = '_atc_';

export const pickCarryOverLineItemProperties = (
  properties?: Record<string, string>,
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(properties ?? {}).filter(([key]) => key.startsWith(CARRY_OVER_PROPERTY_PREFIX)),
  );

export const getLineIdentity = (
  variantId: number,
  properties?: Record<string, string | null | undefined> | null,
): string =>
  JSON.stringify([
    variantId,
    Object.entries(properties ?? {})
      .filter(([, value]) => value !== null && value !== undefined && value !== '')
      .sort(([keyA], [keyB]) => keyA.localeCompare(keyB)),
  ]);

export const getLineQuantities = (
  lines: { variant_id: number; quantity: number; properties?: Record<string, string> | null }[],
): Map<string, number> =>
  lines.reduce((quantities, { variant_id, quantity, properties }) => {
    const lineIdentity = getLineIdentity(variant_id, properties);
    return quantities.set(lineIdentity, (quantities.get(lineIdentity) ?? 0) + quantity);
  }, new Map<string, number>());
